import React from 'react';
import { RED, BLUE, ENTERING_SPACE } from '../../constants';
import GridSquare from './GridSquare';
import styled from 'styled-components';

export const ESWrapper = styled(GridSquare)``;

// color will either be RED or BLUE
export function EnteringSpace({
  className,
  color,
  selected,
  enteringSpacePieces,
}) {
  if (color !== RED && color !== BLUE) {
    throw new Error('EnteringSpace: color must be either RED or BLUE');
  }
  return (
    <ESWrapper className={className} highlight={selected === ENTERING_SPACE}>
      {enteringSpacePieces}
    </ESWrapper>
  );
}
